import { type FC, useLayoutEffect, useState } from "react"

import { query } from "~/utilities/trpc"

import ReactionsModal from "./ReactionsModal"

type Props = { postId: number | null; onClose(): void }
const PostReactions: FC<Props> = ({ postId, onClose }) => {
	const [lastPostId, setLastPostId] = useState<number | null>(null)

	const { data: reactions, error } = query.community.listPostReactions.useQuery(lastPostId!, {
		enabled: lastPostId !== null,
	})

	useLayoutEffect(() => {
		if (postId !== null) {
			setLastPostId(postId)
		}
	}, [postId])

	return <ReactionsModal reactions={reactions} hasError={error !== null} isOpen={postId !== null} onClose={onClose} />
}

export default PostReactions
